/**
 * @flow
 * @relayHash e8dca2d2ccb5186627a77860ec4efef4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteJobSubComponentInput = {|
  itemId: string,
  jobId: string,
|};
export type DeleteJobSubComponentMutationVariables = {|
  input: DeleteJobSubComponentInput
|};
export type DeleteJobSubComponentMutationResponse = {|
  +deleteJobSubComponent: {|
    +deletedItemId: string
  |}
|};
export type DeleteJobSubComponentMutation = {|
  variables: DeleteJobSubComponentMutationVariables,
  response: DeleteJobSubComponentMutationResponse,
|};
*/


/*
mutation DeleteJobSubComponentMutation(
  $input: DeleteJobSubComponentInput!
) {
  deleteJobSubComponent(input: $input) {
    deletedItemId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteJobSubComponentInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteJobSubComponent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteJobSubComponentPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedItemId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteJobSubComponentMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteJobSubComponentMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteJobSubComponentMutation",
    "id": null,
    "text": "mutation DeleteJobSubComponentMutation(\n  $input: DeleteJobSubComponentInput!\n) {\n  deleteJobSubComponent(input: $input) {\n    deletedItemId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'eae04e67cfeac037a76be64563591adb';
module.exports = node;
